import { render } from "./PaywallEmailAccess.vue?vue&type=template&id=4c5cb9db"
import script from "./PaywallEmailAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallEmailAccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallEmailAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c5cb9db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c5cb9db', __exports__)) {
    api.reload('4c5cb9db', __exports__)
  }
  
  module.hot.accept("./PaywallEmailAccess.vue?vue&type=template&id=4c5cb9db", () => {
    api.rerender('4c5cb9db', render)
  })

}


export default __exports__